import { gql } from '@apollo/client';

/**
 * Update company's get-started state (triggered/completed).
 * Called when user triggers or dismisses the checklist widget.
 */
export const UPDATE_GET_STARTED = gql`
  mutation UpdateGetStarted($payload: UpdateGetStartedInput!) {
    updateGetStarted(payload: $payload) {
      triggered
      completed
      completedDate
    }
  }
`;

/**
 * Trigger the firstContentCreated flag when user creates their first asset.
 * This fires once per company lifetime.
 */
export const TRIGGER_FIRST_CONTENT_CREATED = gql`
  mutation TriggerFirstContentCreated {
    triggerFirstContentCreated
  }
`;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface UpdateGetStartedResponse {
  updateGetStarted: {
    triggered: boolean;
    completed: boolean;
    completedDate?: string | null;
  };
}

export interface TriggerFirstContentCreatedResponse {
  triggerFirstContentCreated: boolean;
}
